import { axios } from "@/lib/axios";

import { TokenResponse } from "../types";

export const refresh = async (): Promise<TokenResponse> => {
  return await axios.get("/authentication", { withCredentials: true });
};
